import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/tara';

const initialState = false;

const setIsViewingSurvey = (state, action) => action.payload.isViewingSurvey;

const handlers = {
  [types.TARA_SET_IS_VIEWING_SURVEY]: setIsViewingSurvey,
};

const isViewingSurvey = createReducer(initialState, handlers);

export default isViewingSurvey;

export const getTaraIsViewingSurvey = state => state.tara.isViewingSurvey;



// WEBPACK FOOTER //
// ./src/reducers/tara/isViewingSurvey.js